import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import DiscoverSolid from '@simplywallst/ui-core/icons/DiscoverSolid';
import { getStaticUrl, useCloudflareImage } from '@/hooks/useCloudflareImage';

interface Props {
  title: string;
  content: string;
  link: string;
}

export const EducationalContent = ({ title, content, link }: Props) => {
  const videoImg = useCloudflareImage({
    src: getStaticUrl('dashboard/youTube-thumbnail.png'),
    width: 80,
    height: 50,
    fit: 'cover',
  });
  return (
    <div className="mt-x4 rounded-lg bg-surface-3 p-x2">
      <div className="flex items-center gap-x1">
        <DiscoverSolid className="fill-chart-04" />
        <p className="m-0 text-xs">Quick Tip</p>
      </div>
      <h3 className="mb-x1 mt-x1_25 text-sm font-bold">
        How to react to {title}
      </h3>
      <p className="mb-x1_5 text-xs">{content}</p>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className="grid grid-cols-[max-content_auto_max-content] items-center justify-start gap-x1_5 no-underline"
      >
        <img alt={title} src={videoImg} className="rounded-md" />
        <p className="m-0 text-xs font-strong text-solid">
          Watch the short video on YouTube to learn more
        </p>
        <ChevronRightSmallSolid className="fill-brand-01" />
      </a>
    </div>
  );
};
